<template>
  <a-layout-content>
    <a-row>
      <a-col :xs="24" :sm="12">
        <a-card title="提交拍卖" v-if="user.money">
          <h4>当前资金：{{user.money}}</h4>
          <h4>当前轮数：{{data.lun}}</h4>
          <h4>购价：</h4>
          <a-input-number :min="1" :max="50" v-model="buy" />
          <h4>售价：</h4>
          <a-input-number :min="1" v-model="sold" />
          <a-button type="primary" size="large" @click="submit()">提交</a-button>
        </a-card>
      </a-col>
    </a-row>
    <a-row>
      <a-col>
        <a-card title="竞拍记录">
          <a-table :columns="columns" :dataSource="list">
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </a-layout-content>
</template>
<script>
const columns = [{
  title: '轮数',
  dataIndex: 'lun',
  key: 'lun',
  align: 'center'
}, {
  title: '购价',
  dataIndex: 'buy',
  key: 'buy',
  align: 'center'
}, {
  title: '购价排名',
  dataIndex: 'rank',
  key: 'rank',
  align: 'center'
}, {
  title: '售价',
  dataIndex: 'sold',
  key: 'sold',
  align: 'center'
}
]
export default {
  data () {
    return {
      user: [],
      data: [],
      buy: 1,
      sold: 1,
      columns,
      list: []
    }
  },
  created () {
    this.$http.get('https://auction-api.joyland.top/user').then(res => {
      if (!res.data || res.data.code === 401) {
        this.$message.info('请检查登录状态')
        this.$router.push('/login')
      } else {
        this.user = res.data
      }
    })
    this.$http.get('https://auction-api.joyland.top/system').then(res => {
      this.data = res.data
    })
    this.$http.get('https://auction-api.joyland.top/getlist').then(res => {
      this.list = res.data
    })
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    },
    submit () {
      if (this.sold <= this.buy * 1.5 && this.buy >= 1 && this.buy <= 50 && (/^(-|\+)?\d+$/.test(this.buy)) && (/^(-|\+)?\d+$/.test(this.sold))) {
        const data = {
          uid: this.user.uid,
          lun: this.data.lun,
          cid: this.data.id,
          buy: this.buy,
          sold: this.sold
        }
        this.$http
          .post('https://auction-api.joyland.top/paimai', data)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.info('提交成功！请在下一轮开始时刷新界面')
            } else if (res.data.code === 1000) {
              this.$message.warning('提交失败，请勿连续点击')
            } else if (res.data.code === 1001) {
              this.$message.warning('提交失败，请刷新后重新提交')
            } else if (res.data.code === 1002) {
              this.$message.warning('提交失败，请勿重复提交')
            } else if (res.data.code === 1003) {
              this.$message.warning('提交失败，本场您已经提交过两次该购价')
            }
          })
      } else {
        this.$message.info('提交失败，请检查规则')
      }
    },
    refresh () {
      this.$http.get('https://auction-api.joyland.top/user').then(res => {
        if (!res.data || res.data.code === 401) {
          this.$message.info('请检查登录状态')
          this.$router.push('/login')
        } else {
          this.user = res.data
        }
      })
    }
  }
}
</script>
